import { Option } from '../../../ControlledFields/ControlledSelect';

export const singleSelectValueFormatter = (value: string | number, options: Option[]) => {
  const option = options?.find((options) => options.value === value);
  return option?.label;
};
